<template>


    <section class="max-w-screen-xl px-4 py-6 mx-auto">


        <h4 class="mx-auto mb-4 font-bold text-center h2">

            Clean, Low-Acid Coffee For Your Health

        </h4>

        <div class="flex flex-wrap justify-between w-full max-w-screen-xl px-8 mx-auto">
  <div class="flex flex-col items-center justify-between w-5/12 pt-4 space-y-2 text-center md:w-3/12 md:px-5 xl:space-y-5 md:pt-6"
       v-for="(item, index) in cleanItems" :key="index">

    <nuxt-img width="256" height="256" format="webp" :src="item.src" :alt="item.alt"
              class="" loading="lazy" :sizes="'xs:123px sm:227px md:256px lg:190px xl:256px'" />

    <h4 class="h4 font-ww-medium" v-html="item.title"></h4>
  </div>
</div>



    </section>

</template>

<script setup>
import { ref } from 'vue'

const cleanItems = ref([
  {
    src: '/assets/images/clean-img-1.png',
    alt: 'section image',
    title: 'Amazing<br>Taste',
  },
  {
    src: '/assets/images/clean-img-2.png',
    alt: 'section image',
    title: 'Specialty<br>Beans',
  },
  {
    src: '/assets/images/clean-img-3.png',
    alt: 'section image',
    title: '3rd Party Tested For<br> Toxins',
  },
  {
    src: '/assets/images/clean-img-4.png',
    alt: 'section image',
    title: 'Stomach Friendly, <br> Low Acid',
  }
])

defineBuilderComponent({
    friendlyName: 'TextWhitImages2',
    ignored: true
})
</script>